module.exports = __webpack_public_path__ + "img/home-slider2.59d7a081.jpg";